// Config-key demo for "One wrong word, up to 90 seconds of silence". An
// OrderedOptions-style store accepts any key you set, so a wrong-but-plausible
// name is stored without complaint. Only the exact key the downstream gem
// reads (`browser_options`) reaches Chrome; everything else is stored and
// never used, and the browser launches with none of the intended flags.

export const FERRUM_KEY = "browser_options"
export const FLAGS = ["--no-sandbox", "--disable-dev-shm-usage", "--disable-gpu"]
export const BASE_COMMAND = "chrome --headless"

export function evaluateConfig(key) {
  const normalised = String(key == null ? "" : key).trim()
  const applied = normalised === FERRUM_KEY
  return {
    key: normalised,
    applied,
    status: applied ? "read by Ferrum — flags applied" : "stored, never used",
    ferrumReceived: applied ? FLAGS.slice() : [],
    commandLine: applied ? `${BASE_COMMAND} ${FLAGS.join(" ")}` : BASE_COMMAND
  }
}
